import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import Input from "./Input";
import styled from "styled-components";
const Search = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(Icon, null,
            React.createElement(SearchIcon, null)),
        React.createElement(Input, { search: props.search, setSearch: props.setSearch })));
};
const Wrapper = styled.div `
  padding: 10px;
  background-color: transparent;
  margin: 0;
  display: flex;
  align-items: center;
`;
const Icon = styled.div `
  color: ${({ theme }) => theme.search.icon.color};
`;
export default Search;
//# sourceMappingURL=index.js.map